import { render, staticRenderFns } from "./ItineraryPreview.vue?vue&type=template&id=15d552e0&"
import script from "./ItineraryPreview.vue?vue&type=script&lang=js&"
export * from "./ItineraryPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports